export const EVALUATIE_QUERY_KEY = "evaluatie";
